/**
 * Utility functions for video-related operations
 */

/**
 * Remove file extension from video filename for display purposes
 * @param filename - The original filename
 * @returns Filename without extension
 */
export const getDisplayTitle = (filename: string): string => {
  return filename.replace(/\.(mp4|mkv|avi|mov|wmv|flv|webm|m4v)$/i, '');
};

/**
 * Check if a file size is valid (greater than 0)
 * @param fileSize - File size in bytes
 * @returns True if file size is valid
 */
export const isValidFileSize = (fileSize: number): boolean => {
  return fileSize > 0;
};
